import { Users } from 'lucide-react'

import { SkeletonItem } from 'components/reusable/SkeletonItem'
import { formatMoney } from 'utils'

import { type CostBreakdownItem } from '../types'

interface InvoiceCostBreakdownMobileProps {
  items: CostBreakdownItem[]
  isLoading?: boolean
}

export function InvoiceCostBreakdownMobile ({ items, isLoading }: InvoiceCostBreakdownMobileProps) {
  return (
    <div className='md:hidden space-y-0 p-4'>
      {items.map((item, index) => (
        <div key={index}>
          {index > 0 && <hr className='border-gray-200 my-4' />}
          <div className='flex items-start justify-between mb-2'>
            <div className='body flex-1 pr-4'>{item.title}</div>
            <div className='body text-right'>
              {isLoading ? <SkeletonItem heightClass='h-5' widthClass='w-20' /> : item.amount}
            </div>
          </div>
          <div className='flex items-center gap-2 mb-2'>
            <Users size={16} className='text-gray-500' />
            <span className='body-sm text-gray-500'>
              {item.employeeCount != null
                ? `${item.employeeCount} employee${item.employeeCount > 1 ? 's' : ''}`
                : '---'}
              {item.perUnitAmount !== undefined && ` • ${formatMoney(item.perUnitAmount)} each`}
            </span>
          </div>
          <div className='body-sm text-gray-500 mb-2'>
            {item.description}
          </div>
          {item.link && (
            <a href={item.link.href} className='body-sm text-purple-600 block underline decoration-dotted'>
              {item.link.text}
            </a>
          )}
          {item.modalTrigger && (
            <div className='mt-1'>
              {item.modalTrigger}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
